import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import fleetAppointmentDetailsAtom from "../../atoms/fleetAppointmentDetailsAtom";
import { url } from '../../utils/config';
import axios from "axios";
import { toast } from "react-toastify";
import arrowBlack from '../../assets/icons/arrow_black.png'
import loaderStateAtom from "../../atoms/loaderStateAtom";
import FleetViewWorkOrder from "../B2B/FleetViewWorkOrder";
import { btnOne } from "../../utils/style";

function FleetAppointmentDetails({ setShowFleetAppointmentDetails, getFleetAppointments, fetchFleetAppointmentDetails }) {
    const [appointmentDetails, setAppointmentDetails] = useRecoilState(fleetAppointmentDetailsAtom);
    const [showWorkOrderForm, setShowWorkOrderForm] = useState(false);
    const [showLoader, setShowLoader] = useRecoilState(loaderStateAtom)

    function fetchAppointmentDetails(id) {
        if (!id) {
            return
        }
        setShowLoader(true)
        const reqUrl = url + '/fleet_appointment_details/' + id;
        const token = window.localStorage.getItem('token');
        const headers = { authorization: `bearer ${token}` };
        axios.get(reqUrl, { headers })
            .then(res => {
                setAppointmentDetails(res.data.data);
            })
            .catch(error => {
                toast.error(error?.response?.data?.message || '', { autoClose: 3000 })
            }).finally(() => {
                setShowLoader(false)
            })
    }

    const refreshHandler = () => {
        fetchAppointmentDetails(appointmentDetails.id)
    }


    const cancelApponitmentHandler = async (id) => {
        try {
            const token = window.localStorage.getItem('token');
            const response = await axios.delete(`${url}/fleet_booking/${id}`, {
                headers: { authorization: `bearer ${token}` }
            });
            if (response.status === 200) {
                toast.success("Appointment cancelled successfully", { autoClose: 3000 });
                getFleetAppointments();
                setShowFleetAppointmentDetails(false);
            } else {
                toast.error("Failed to cancel the appointment", { autoClose: 3000 });
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "An error occurred while cancelling the appointment", { autoClose: 3000 });
        }
    };

    const closeApponitmentHandler = async (id) => {
        try {
            const token = window.localStorage.getItem('token');
            const response = await axios.get(`${url}/complete_fleet_service/${id}`, {
                headers: { authorization: `bearer ${token}` }
            });
            if (response.status === 200) {
                toast.success(response.data.message, { autoClose: 3000 });
                getFleetAppointments();
                setShowFleetAppointmentDetails(false);
            } else {
                toast.error("Failed to close the appointment", { autoClose: 3000 });
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "An error occurred while closing the appointment", { autoClose: 3000 });
        }
    };

    function getWorkEstimateStatus(estimates) {

        const keysToCheck = ['materialList', 'serviceList', 'otherList', 'bundleList'];
        const allNull = estimates.every(obj =>
            keysToCheck.every(key => (obj[key] === null || obj[key].data.length === 0))
        );
        return !allNull
    }

    function renderOption(estimate) {
        return (
            <div className="flex flex-col items-center justify-center">
                {
                    appointmentDetails.bypassApproval === "no" && estimate[0].status === "Pending" ?
                        <div className="text-black text-center">Approval Pending From User's End!</div>
                        :
                        appointmentDetails.bypassApproval === "no" && estimate[0].status === "Approved" ?
                            <div className="text-black text-center">Estimate Approved From User's End!</div>
                            :
                            appointmentDetails.bypassApproval === "no" && estimate[0].status === "Rejected" ?
                                <>
                                    <div className="text-red-500">Work Estimate Has Been Rejected!</div>
                                    <div className="border rounded-lg bg-gray-100 shadow-sm w-full px-4 py-2 m-2 break-words"><span className="font-semibold">Decline Reason:</span> {estimate[0].estimateDeclineMessage}</div>

                                    <div className="w-full">
                                        <button className={btnOne} onClick={() => { setShowWorkOrderForm(true) }} >Modify Work Estimate</button>
                                    </div>
                                </>
                                :
                                <div className="w-full">
                                    <button className={btnOne} onClick={() => { setShowWorkOrderForm(true) }} >Create Work Estimate</button>
                                </div>
                }
            </div>
        )

    }

    return (
        !showWorkOrderForm
            ? (
                <div className="h-full bg-gray-50">
                    {/* Fixed Header */}
                    <div className="sticky top-0 bg-white border-b z-10 py-2">
                        <div className="flex items-center justify-start">
                            <div className="flex items-center">
                                <button
                                    className=" hover:bg-gray-100 rounded-full"
                                    onClick={() => setShowFleetAppointmentDetails(false)}
                                >
                                    <img src={arrowBlack} className="w-5 h-5" alt="back" />
                                </button>
                                <h2 className="ml-2 text-base font-medium">Appointment Details</h2>
                            </div>
                        </div>
                    </div>

                    {/* Scrollable Content */}
                    <div className="p-3 space-y-3">
                        {/* Quick Info Card */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="grid grid-cols-2 gap-3 mb-3">
                                <div>
                                    <div className="text-xs text-gray-500">Name</div>
                                    <div className="text-sm font-medium">{appointmentDetails?.fleet_customer.name}</div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500">Phone</div>
                                    <div className="text-sm font-medium">{appointmentDetails?.fleet_customer.phone}</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                                <div>
                                    <div className="text-xs text-gray-500">Email</div>
                                    <div className="text-sm break-words">{appointmentDetails?.fleet_customer.email}</div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500">Payment Terms</div>
                                    <div className="text-sm">{appointmentDetails?.fleet_customer.paymentTerms}</div>
                                </div>
                            </div>
                        </div>

                        {/* Schedule & Location */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="grid grid-cols-2 gap-3 mb-3">
                                <div>
                                    <div className="text-xs text-gray-500">Date</div>
                                    <div className="text-sm font-medium">{appointmentDetails.date}</div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500">Time</div>
                                    <div className="text-sm font-medium">{appointmentDetails?.time}</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                                <div>
                                    <div className="text-xs text-gray-500">Country</div>
                                    <div className="text-sm">{appointmentDetails?.fleet_customer?.country || ""}</div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500">State</div>
                                    <div className="text-sm">{appointmentDetails?.fleet_customer?.state_province || ""}</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                                <div>
                                    <div className="text-xs text-gray-500">City</div>
                                    <div className="text-sm">{appointmentDetails?.fleet_customer?.city || ""}</div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500">ZIP/Postal Code</div>
                                    <div className="text-sm">{appointmentDetails?.fleet_customer?.postal_code || ""}</div>
                                </div>
                            </div>
                            <div>
                                <div className="text-xs text-gray-500">Address</div>
                                <div className="text-sm">{appointmentDetails?.fleet_customer?.address}</div>
                            </div>
                        </div>

                        {/* Vehicle Info */}
                        <table className="border border-gray-200 text-sm p-3 rounded-lg shadow-sm">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="text-left px-4 py-2 border-b">Car</th>
                                    <th className="text-left px-4 py-2 border-b">VIN</th>
                                </tr>
                            </thead>
                            <tbody>
                                {appointmentDetails.fleet_work_estimates?.length > 0 ? (
                                    appointmentDetails.fleet_work_estimates.map((estimate, index) => {
                                        const car = estimate?.fleet_customer_car || {};
                                        return (
                                            <tr key={estimate.id || index} className="hover:bg-gray-50">
                                                <td className="px-4 py-2 border-b">
                                                    {car.make || ''}-{car.model || ''}-{car.year || ''}
                                                </td>
                                                <td className="py-2 border-b">
                                                    {car.vin || ''}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={2} className="text-center px-4 py-3 text-gray-500">
                                            No car available.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Service Details */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="space-y-2">
                                {appointmentDetails?.problemDescription && (
                                    <div>
                                        <div className="text-xs text-gray-500">Description</div>
                                        <div className="text-sm">{appointmentDetails.problemDescription}</div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Work Estimate */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="text-xs text-gray-500 mb-1 flex justify-between p-3 rounded-lg shadow-sm">
                                <p className="font-medium">Work Estimate</p>
                                <span className="flex items-center" onClick={refreshHandler}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                    </svg>
                                </span>
                            </div>
                            <div className="text-sm">
                                {renderOption(appointmentDetails?.fleet_work_estimates)}
                            </div>
                        </div>


                        {/* Fixed Bottom Actions */}
                        {
                            (appointmentDetails.bypassApproval === "yes" && getWorkEstimateStatus(appointmentDetails.fleet_work_estimates)) || (appointmentDetails.bypassApproval === "no" && appointmentDetails.fleet_work_estimates?.some(item => item.status === 'Approved'))
                                ?
                                <div className="bg-white p-3 border-t">
                                    <button className="flex-1 py-2 px-2 bg-green-600 text-white rounded-md text-sm w-full" onClick={() => { closeApponitmentHandler(appointmentDetails.id) }}>
                                        Complete Appointment
                                    </button>
                                </div>
                                :

                                appointmentDetails.bypassApproval === "no" && appointmentDetails.fleet_work_estimates[0].status === "Pending" ? "" :

                                    <div className="bg-white p-3 border-t">
                                        <button className="flex-1 py-2 px-2 bg-red-500 text-white rounded-md text-sm w-full" onClick={() => { cancelApponitmentHandler(appointmentDetails.id) }}>
                                            Cancel Appointment
                                        </button>
                                    </div>
                        }
                    </div>
                </div>
            )
            : (
                <FleetViewWorkOrder
                    setShowModal={setShowWorkOrderForm}
                    appointmentDetails={appointmentDetails}
                    fetchFleetAppointmentDetails={fetchFleetAppointmentDetails}
                />

            )
    )
}

export default FleetAppointmentDetails;
